import ChooseRolledFromContainer from './components/ChooseRolledFromContainer';
import ContainerOperationMenu from './components/ContainerOperationMenu';
import DefineContainerPeriods from './components/DefineContainerPeriods';
import NameContainer from './components/NameContainer';

export const PANELS = [ContainerOperationMenu, ChooseRolledFromContainer, DefineContainerPeriods, NameContainer];
